import ZkDropdown from './src/dropdown';

/* istanbul ignore next */
ZkDropdown.install = function(Vue) {
  Vue.component(ZkDropdown.name, ZkDropdown);
};

export default ZkDropdown;



// WEBPACK FOOTER //
// ./src/packages/dropdown/index.js